module.exports = __webpack_public_path__ + "static/media/money1.1e54addd.jpg";